import React, { useState } from "react";
import { makeStyles } from "@material-ui/styles";

import { DeleteDialog, ShipmentToolbar } from "./components";
import mockData from "./data";
import ListShipmentTable from "./components/ListShipmentTable/ListShipmentTable";
import EditShipment from "./components/EditShipment";
import { useMediaQuery } from "@material-ui/core";
import theme from "theme";
import { useSelector } from "react-redux";

const useStyles = makeStyles((theme) => ({

  root: {
    padding: theme.spacing(3),
  },
  rootSmall: {
    padding: 0,
  },
  content: {
    marginTop: theme.spacing(2),
  },
}));

const ListShipment = () => {
  const classes = useStyles();
  const isSmall = useMediaQuery(theme.breakpoints.down('xs'));
  let Pr_inventory = useSelector((state) => state.permission);
  const current_role = useSelector((state) => state.role);

  const [reloadPage, setReloadpage] = useState(false);
  function reloadFunction() {
    setReloadpage(!reloadPage);
  }

  const [data] = useState(mockData);
  const [showDeleteDialog, setShowDeleteDialog] = useState(false);
  const toggleDeleteDialog = () => {
    setShowDeleteDialog(!showDeleteDialog);
  };

  const [showEditDialog, setEditInfoDialog] = useState(false);
  const toggleEditDialog = () => setEditInfoDialog(!showEditDialog);

  const [idSel, setIdSelDialog] = useState("0");

  function handleIdChange(newId) {
    setIdSelDialog(newId);
  }

  const [DataSel, setDataSel] = useState([]);

  function SelectData(newData) {
    setDataSel(newData);
  }

  return (
    <div className={isSmall ? classes.rootSmall : classes.root}>


      {showDeleteDialog ? (
        <DeleteDialog
          id={idSel}
          reloadFunc={reloadFunction}
          type="Employee"
          onClose={toggleDeleteDialog}
          open={showDeleteDialog}
          title="حذف بارنامه"
          desc={DataSel}
        />
      ) : (
        ""
      )}

      {/* 
      <DeleteDialog
        title="حذف بارنامه"
        open={showDeleteDialog}
        onAccept={toggleDeleteDialog}
        onClose={toggleDeleteDialog}
      /> */}

      {/* <EditShipment
        onAccept={toggleEditDialog}
        onClose={toggleEditDialog}
        data={data || undefined}
        id={idSel}
        title="اطلاعات بیشتر" 
        open={showEditDialog}
      /> */}



      {showEditDialog ? (
        <EditShipment
          onAccept={toggleEditDialog}
          onClose={toggleEditDialog}
          data={data || undefined}
          id={idSel}
          reloadFunc={reloadFunction}
          title="اطلاعات بیشتر"
          open={showEditDialog}
        />
      ) : (
        ""
      )}


      {/* <ShipmentToolbar  /> */}
      <div className={classes.content}>
        <ListShipmentTable
          ChangeId={handleIdChange}
          showEdit={toggleEditDialog}
          onDelete={toggleDeleteDialog}
          data={data}
          selData={SelectData}
          reload={reloadPage}
          reloadFunc={reloadFunction}

          edit={showEditDialog}
          del={showDeleteDialog}

        />
      </div>
    </div>
  );
};

export default ListShipment;
